import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/layouts/AdminLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { StockTab } from "@/components/inventory/StockTab";
import { LocationsTab } from "@/components/inventory/LocationsTab";
import { MovementsTab, SerialsTab } from "@/components/inventory/HistoryTabs";
import { InventoryConfigTab } from "@/components/inventory/InventoryConfigTab";
import { HolderTab } from "@/components/inventory/HolderTab";

export default function Inventory() {
  const { can } = useAuth();
  const [locations, setLocations] = useState([]);
  const loadLocations = useCallback(() => api.get("/inventory/locations").then((r) => setLocations(r.data)), []);
  useEffect(() => { loadLocations(); }, [loadLocations]);
  return (
    <div data-testid="inventory-page">
      <PageHeader eyebrow="Catálogo / Inventario" title="Inventario" />
      <p className="-mt-4 mb-6 max-w-3xl text-sm text-muted-foreground">El catálogo define qué es cada artículo; el inventario cuánto existe y dónde está. Toda existencia cambia solo mediante movimientos auditados.</p>
      <Tabs defaultValue="stock">
        <TabsList className="mb-4 flex-wrap" data-testid="inventory-tabs">
          <TabsTrigger value="stock" data-testid="inv-tab-stock">Existencias</TabsTrigger>
          <TabsTrigger value="movements" data-testid="inv-tab-movements">Movimientos</TabsTrigger>
          <TabsTrigger value="locations" data-testid="inv-tab-locations">Ubicaciones</TabsTrigger>
          <TabsTrigger value="serials" data-testid="inv-tab-serials">Números de serie</TabsTrigger>
          <TabsTrigger value="holders" data-testid="inv-tab-holders">Por responsable</TabsTrigger>
          {can("settings.write") && <TabsTrigger value="config" data-testid="inv-tab-config">Clasificación y unidades</TabsTrigger>}
        </TabsList>
        <TabsContent value="stock"><StockTab locations={locations} /></TabsContent>
        <TabsContent value="movements"><MovementsTab /></TabsContent>
        <TabsContent value="locations"><LocationsTab locations={locations} reload={loadLocations} /></TabsContent>
        <TabsContent value="holders"><HolderTab /></TabsContent>
        <TabsContent value="serials"><SerialsTab /></TabsContent>
        {can("settings.write") && <TabsContent value="config"><InventoryConfigTab /></TabsContent>}
      </Tabs>
    </div>
  );
}
